import React from "react";
import "./OnwerHomeNew.css";
import OverviewHeader from "./OwnerHomeNewComponents/OverviewHeader";
import UpcomingMeetingsOwner from "./OwnerHomeNewComponents/UpcomingMeetingsOwner";
import Hometabs from "../hometabs/Hometabs";
import TopPerformers from "./OwnerHomeNewComponents/TopPerformers";
import ParticipantTrends from "./OwnerHomeNewComponents/ParticipantTrends";

const OnwerHomeNew = () => {
    return (
        <div className="lg:flex w-[100%] gap-6" style={{ alignItems: "start" }}>
            {/* LEFT SECTION */}
            <div className="space-y-6 lg:w-[52%] xl:w-[59%] 2xl:w-[64%]">
                <OverviewHeader />
                <ParticipantTrends />
                <Hometabs />
            </div>

            {/* RIGHT SECTION */}
            <div className="space-y-6 lg:w-[48%] xl:w-[41%] 2xl:w-[36%] mt-6 lg:mt-0">
                <UpcomingMeetingsOwner />
                <TopPerformers />
            </div>

        </div>
    );
};

export default OnwerHomeNew;
